import { CountryCode, ProductRecommendationIntent } from './schemas';

type GraphQLError = {
  message: string;
  extensions?: {
    value: string;
    problems: {
      explanation: string;
      message: string;
      path: string[];
    }[];
  };
  locations?: {
    column: number;
    line: number;
  }[];
};

export const isGraphqlError = (error: unknown): error is GraphQLError[] => {
  return Array.isArray(error) && error.length && error[0].message;
};

export const isCountryCode = (country: string): country is CountryCode => {
  return Object.values(CountryCode).includes(country as CountryCode);
};

export const isProductRecommendationIntent = (
  intent: string
): intent is ProductRecommendationIntent => {
  return Object.values(ProductRecommendationIntent).includes(intent as ProductRecommendationIntent);
};
